module.exports = __webpack_public_path__ + "static/media/A13.561a68fc.png";